export const REQUIRED_MSG = 'This field is required';
export const SUPPORT_EMAIL = 'info@keyown.com';
export const COMMUNITY_EMAIL = 'community@keyown.com';
export const HOME_SEARCH_STORAGE_ID = 'homeSearchParams';
